import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-projects-style-two',
  templateUrl: './projects-style-two.component.html',
  styleUrls: ['./projects-style-two.component.scss']
})
export class ProjectsStyleTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
